import { memo } from 'react';
import { useState } from 'react';
import { TableCell, TableHead, TableRow, Typography, Button } from '@mui/material';
import AddCountryOfImport from './AddCountryOfImport';
import { Dialog } from '../../style-guide';

const CountryOfImportHeader = () => {
    const [openOrderModal, setOpenOrderModal] = useState(false);
    const onHandleOpenModal = () => setOpenOrderModal(true);
    const onHandleCancelModal = () => setOpenOrderModal(false);

    return (
        <TableHead>
            <TableRow>
                <TableCell />

                <TableCell>
                    <Typography variant='h7'>
                        Description
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant='h7'>Operations</Typography>
                </TableCell>
                <TableCell>
                    <Typography variant='h7'>
                        <Button onClick={onHandleOpenModal} variant='contained'>
                            + New Country Of Import
                        </Button>
                        {openOrderModal && (
                            <Dialog open={openOrderModal} title={'Country Of Import'} onHandleCancel={onHandleCancelModal}>
                                <AddCountryOfImport onHandleCancel={onHandleCancelModal} id={null} />
                            </Dialog>
                        )}
                    </Typography>
                </TableCell>
            </TableRow>
        </TableHead>
    );
};

export default memo(CountryOfImportHeader);
